export const XS = 'xs';
export const S = 's';
export const M = 'm';
export const L = 'l';
export const XXL = 'xxl';

export const DEFAULT_SIZE = L;

export const SIZES = [XS, S, M, L, XXL];

export const WHITE = 'white';
export const BLUE = 'blue';
export const GREY = 'grey';
export const BLACK = 'black';

export const DEFAULT_THEME = WHITE;

export const THEMES = [WHITE, BLUE, GREY, BLACK];

const BODY_TEXT = 'body-text';
const CAPTION = 'caption';
const SUBTITLE = 'subtitle';

export const DEFAULT_KIND = BODY_TEXT;

export const KINDS = [BODY_TEXT, CAPTION, SUBTITLE];

const PARENT_H3 = 'h3';

export const PARENT_TYPES = [PARENT_H3];

export const PRIORITIES = [0, 1, 2, 3, 4, 5];
